import PropTypes from "prop-types"

import { DISCOUNT_TEMPLATE, PROMO_CODE } from "./constants"

export const storageProductPropTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export const billingSchedulePropTypes = {
  schedule: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  short_term_default: PropTypes.bool.isRequired,
  long_term_default: PropTypes.bool.isRequired,
}

export const electricProductPropTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultPricingStructure: PropTypes.string,
}

export const ratePropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  amount: PropTypes.number,
  taxRate: PropTypes.number,
  mbmTranslatedPricingStructure: PropTypes.string,
}

export const couponCodePropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  code: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
  discountText: PropTypes.string,
  membershipAffiliation: PropTypes.string,
  type: PropTypes.oneOf([DISCOUNT_TEMPLATE, PROMO_CODE]).isRequired,
}
